import t from"styled-components";const o=t.div`
	position: relative;
	border-radius: ${({borderRadius:t})=>`${t}px`};
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	overflow: hidden;
	background-color: ${({theme:t})=>t.bg.card};
	border: 0.71px solid ${({theme:t})=>t.border.black10};
	padding: 14px;
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	box-sizing: border-box;
	gap: 14px;
	height: 100%;
`,i=t.h1`
	margin: 0;
	font-size: 18px;
	font-weight: 500;
	color: ${({theme:t})=>t.text.input};
	padding-top: 7px;
	cursor: ${({isEditable:t=!1})=>t?"text":"default"};
`,e=t.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
`,p=t.div`
	display: flex;
	gap: 12px;
	align-items: start;

	padding-right: ${({hasLabel:t})=>t?"0":"24px"};

	svg {
		fill: ${({color:t})=>t};

		path {
			fill: ${({color:t})=>t};
		}
	}

	${({hideIcon:t})=>t?"\n\t\t\t\t& > div:first-child {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t":""}
`,r=t.p`
	margin: 0;
	color: #acacac;
	font-size: 14px;
	line-height: 18px;
	white-space: pre-wrap;
	cursor: ${({isEditable:t=!1})=>t?"text":"default"};
`,n=t.span`
	padding: 5px 10px;
	font-size: 12px;
	color: ${({color:t})=>t};
	background: ${({background:t})=>t};
	border-radius: 9999px;
	max-width: 80%;
	width: fit-content;
	cursor: ${({isEditable:t=!1})=>t?"text":"default"};
`,d=t.div`
	position: absolute;
	bottom: 5px;
	right: 10px;
	opacity: 0.5;

	${({arrowOnTop:t=!1})=>t?"\n    bottom: 10px;\n    right: 10px;\n  ":"\n    top: 20px;\n    right: 10px;\n  "}
`,a=t.div`
	font-size: 28px;
	cursor: pointer;
`;export{d as CardArrowContainer,o as CardContainer,e as CardContent,a as CardEmoji,p as CardHeader,i as CardHeading,n as CardLabel,r as CardParagraph};
